import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'D&D Twogether - Flowers and more';
  hideShell = false;
  private routerSubscription: Subscription;
  private languageSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private meta: Meta
  ) {
    this.translate.setDefaultLang('hu'); // Alapértelmezett nyelv
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang?.match(/en|hu|ru/) ? browserLang : 'hu');
    this.hideShell = this.isShellHiddenRoute(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.hideShell = this.isShellHiddenRoute(event.urlAfterRedirects);
        this.updateSeoTags(event.urlAfterRedirects);
      });
    this.languageSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateSeoTags(this.router.url);
    });
    this.updateSeoTags(this.router.url);
  }

  onLanguageChanged(language: string) {
    this.translate.use(language); // Nyelv váltása
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.languageSubscription.unsubscribe();
  }

  private isShellHiddenRoute(url: string): boolean {
    return ['/links', '/wedding'].includes(url.split('?')[0].split('#')[0].replace(/\/$/, ''));
  }

  private updateSeoTags(url: string): void {
    const data = this.getActiveRouteData();
    const titleKey = typeof data['titleKey'] === 'string' ? data['titleKey'] : 'seo.home.title';
    const descriptionKey = typeof data['descriptionKey'] === 'string'
      ? data['descriptionKey']
      : 'seo.home.description';

    this.translate.get([titleKey, descriptionKey]).subscribe((translations) => {
      const translatedTitle = translations[titleKey];
      const translatedDescription = translations[descriptionKey];
      const title = typeof translatedTitle === 'string' ? translatedTitle : this.title;
      const description = typeof translatedDescription === 'string' ? translatedDescription : '';

      this.titleService.setTitle(title);
      this.meta.updateTag({ name: 'description', content: description });
      this.meta.updateTag({ property: 'og:title', content: title });
      this.meta.updateTag({ property: 'og:description', content: description });
      this.meta.updateTag({ name: 'twitter:title', content: title });
      this.meta.updateTag({ name: 'twitter:description', content: description });
    });

    this.updateCanonicalUrl(url);
  }

  private getActiveRouteData(): Data {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.data;
  }

  private updateCanonicalUrl(url: string): void {
    const path = url.split('?')[0].split('#')[0] || '/';
    const canonicalUrl = `https://www.twogetherflower.hu${path === '/' ? '' : path}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    link.setAttribute('href', canonicalUrl);
  }
  
}
